import { render, staticRenderFns } from "./ProviderAvailAppt.vue?vue&type=template&id=3fa12fac&scoped=true&"
import script from "./ProviderAvailAppt.vue?vue&type=script&lang=js&"
export * from "./ProviderAvailAppt.vue?vue&type=script&lang=js&"
import style0 from "./ProviderAvailAppt.vue?vue&type=style&index=0&id=3fa12fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa12fac",
  null
  
)

export default component.exports